import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-hero" }
const _hoisted_2 = { class: "hero-icon-wrap" }
const _hoisted_3 = { class: "current-info" }
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = { class: "current-channel-badge" }
const _hoisted_6 = { class: "channel-section" }
const _hoisted_7 = { class: "channel-options" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "channel-radio" }
const _hoisted_10 = {
  key: 0,
  class: "radio-dot"
}
const _hoisted_11 = { class: "channel-info" }
const _hoisted_12 = { class: "channel-name" }
const _hoisted_13 = { class: "channel-desc" }
const _hoisted_14 = {
  key: 0,
  class: "current-tag"
}

import { ref, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Switch, Check } from "@element-plus/icons-vue";
import { changeChannelApi } from "@/api/cert/certBatchApi";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeChannelDialog',
  props: {
    modelValue: { type: Boolean },
    endpointId: {},
    currentChannel: {},
    deviceId: {}
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(props.modelValue);
const selectedChannel = ref(1);
const submitting = ref(false);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
    if (val) {
      selectedChannel.value = props.currentChannel || 1;
    }
  }
);
watch(visible, (val) => emit("update:modelValue", val));

const handleClose = () => {
  selectedChannel.value = 1;
};

const handleSubmit = async () => {
  if (selectedChannel.value === props.currentChannel) {
    ElMessage.warning("新频道与当前频道相同");
    return;
  }

  try {
    await ElMessageBox.confirm(
      `确认将终端 ${props.deviceId} 从频道 ${props.currentChannel} 切换到频道 ${selectedChannel.value}？`,
      "确认切换频道",
      {
        type: "warning",
        confirmButtonText: "确认切换",
        cancelButtonText: "取消",
      }
    );
  } catch {
    return;
  }

  submitting.value = true;
  try {
    await changeChannelApi(props.endpointId, selectedChannel.value);
    ElMessage.success(`已切换到频道 ${selectedChannel.value}`);
    emit("success");
    visible.value = false;
  } catch (e: any) {
    ElMessage.error(e.message || "切换失败");
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "切换频道",
    width: "520px",
    "close-on-click-modal": false,
    class: "channel-dialog",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("取消", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        loading: submitting.value,
        disabled: selectedChannel.value === __props.currentChannel,
        class: "submit-btn",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Check))
            ]),
            _: 1
          }),
          _createElementVNode("span", null, "确认切换到频道 " + _toDisplayString(selectedChannel.value), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_icon, {
            size: 22,
            color: "#fff"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Switch))
            ]),
            _: 1
          })
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hero-text" }, [
          _createElementVNode("h3", null, "切换终端频道"),
          _createElementVNode("p", null, "切换设备接入链路标识，可用于重置安全凭证")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info-label" }, "终端编号", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.deviceId || "(无)"), 1),
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "info-label",
          style: {"margin-top":"12px"}
        }, "当前频道", -1)),
        _createElementVNode("div", _hoisted_5, "频道 " + _toDisplayString(__props.currentChannel), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "section-title" }, "选择新频道", -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (ch) => {
            return _createElementVNode("div", {
              key: ch,
              class: _normalizeClass(["channel-option", {
            active: selectedChannel.value === ch,
            current: ch === __props.currentChannel,
          }]),
              onClick: ($event: any) => (selectedChannel.value = ch)
            }, [
              _createElementVNode("div", _hoisted_9, [
                (selectedChannel.value === ch)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, "频道 " + _toDisplayString(ch), 1),
                _createElementVNode("div", _hoisted_13, [
                  (ch === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("默认接入组")
                      ], 64))
                    : (ch === 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("备用接入组 A")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode("备用接入组 B")
                        ], 64))
                ])
              ]),
              (ch === __props.currentChannel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "当前"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_8)
          }), 64))
        ])
      ]),
      _createVNode(_component_el_alert, {
        type: "warning",
        closable: false,
        class: "warn-alert"
      }, {
        title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "warn-text" }, [
            _createTextVNode(" · 切换后旧频道将被拉黑，终端会被踢线"),
            _createElementVNode("br"),
            _createTextVNode(" · 终端固件需循环尝试三个频道找到新活跃频道"),
            _createElementVNode("br"),
            _createTextVNode(" · endpointId 和绑船关系保持不变 ")
          ], -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})